/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterDailyMonitoring } from '../types/FilterDailyMonitoring'
import { defaultFormatTimeZone } from '../utils/consts'

interface DailyMonitoringFiltersContextType {
  filters: FilterDailyMonitoring
  setFilters: (filters: FilterDailyMonitoring) => any
}
const initialState: DailyMonitoringFiltersContextType = {
  filters: {
    pharmacies: [],
    states: [],
    cities: [],
    orderStatus: null,
    clients: [],
    paymentMethods: [],
    dateRange: {
      initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    },
    orderCount: [0, 300],
    orderTotals: {
      initial: 0,
      final: 4000
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-daily-monitoring-main-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const DailyMonitoringFiltersContext = createContext(initialState)

const DailyMonitoringFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <DailyMonitoringFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </DailyMonitoringFiltersContext.Provider>)
}

export default DailyMonitoringFiltersContextProvider
